import React from "react";
import PropTypes from "prop-types"; // Import PropTypes for prop validation
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Tooltip from "@mui/material/Tooltip"; // Import Tooltip
import { alpha } from "@mui/material/styles";

const JumboIconButton = ({
  children,
  elevation,
  badge,
  tooltip,
  tooltipPlacement = "top", // Optional prop for tooltip placement
  ...restProps
}) => {
  // The content to be rendered (IconButton with or without Badge)
  const buttonContent = (
    <IconButton
      sx={{
        width: 40,
        height: 40,
        boxShadow: elevation,
        padding: 1.25,
      }}
      {...restProps}
    >
      {badge ? (
        <Badge
          variant={badge.variant}
          sx={{
            "& .MuiBadge-badge": {
              top: -5,
              right: -5,
              width: 12,
              height: 12,
              borderRadius: "50%",
              border: 2,
              borderColor: "common.white",
              boxShadow: (theme) =>
                `0 0.5rem 1.25rem ${alpha(theme.palette.primary.main, 0.7)}`,
              backgroundImage: (theme) =>
                `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            },
          }}
        >
          {children}
        </Badge>
      ) : (
        children
      )}
    </IconButton>
  );

  // Conditionally wrap the button content with a Tooltip if tooltip prop is provided
  return tooltip ? (
    <Tooltip title={tooltip} placement={tooltipPlacement} arrow>
      {buttonContent}
    </Tooltip>
  ) : (
    buttonContent
  );
};

// PropTypes for prop validation
JumboIconButton.propTypes = {
  children: PropTypes.node.isRequired,
  elevation: PropTypes.number,
  badge: PropTypes.shape({
    variant: PropTypes.string,
  }),
  tooltip: PropTypes.string, // Tooltip text (optional)
  tooltipPlacement: PropTypes.string, // Tooltip placement (optional)
};

export default JumboIconButton;
